import React, { useState, useEffect } from 'react';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Flag from '@atlassian/jira-flags/src/common/ui/components/ak-flag';
import FlagGroup from '@atlassian/jira-flags/src/common/ui/components/group-flag';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { ServiceError } from '../../../../../common/types/service.tsx';
import messages from './messages';

type Props = {
	error: ServiceError;
	metricName: string;
} & Intl;
const FlagsComponent = ({ error, metricName, intl }: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		if (error) {
			setIsOpen(true);
		}
	}, [error, setIsOpen]);

	return (
		<FlagGroup onDismissed={() => setIsOpen(false)}>
			{isOpen ? (
				<Flag
					icon={<ErrorIcon label="" primaryColor={token('color.icon.danger', colors.R400)} />}
					id="error"
					key="error"
					title={intl.formatMessage(messages.errorTitle)}
					description={intl.formatMessage(messages.errorDescription, { metricName })}
				/>
			) : null}
		</FlagGroup>
	);
};

export const Flags = injectIntl(FlagsComponent);
